<h1 class="sr-only"><span>PUNTOS DE VENTA SORTEO ANÁHUAC MAGNO 2026</span></h1>
<section class="punto-venta-proximo banner-padding">
    <div class="container">
        <div class="row sub-headers-inside">

            <div class="col-lg-6 my-auto d-lg-block d-none">
                <img src="/assets/images/sorteo2026/puntos-venta.png" class="img-fluid"
                    alt="Puntos de venta Sorteo Anáhuac" width="500">
            </div>

            <div class="col-lg-6 my-auto text-center">
                <h2>
                    Próximamente
                </h2>
                <p>
                    Puntos de venta de
                    boletos físicos.
                </p>
                <a routerLink="/">
                    home
                </a>
            </div>


        </div>
    </div>
</section>